<template>
	<section class="section section_report" style="min-height: 600px;">
		<LoadingOverlay :activeSyncProps="activeSync" :isFullPageProps="false"/>
		<div class="section_wrap rom-graph-section row">
			<h6 class="--blue70">
        {{ $t( 'report.rom_change_monitoring' ) }}
      </h6>
			<div class="section_body">
				<graphSideMenu :patientInfoProps="patientInfoProps" :romChartDataProps="romChartData"
					@getDataForFilteredRomAndExerciseTimeByRange="getDataForFilteredRomAndExerciseTimeByRange" ref="graphSideMenu"/>
				<RomGraphSection :romChartDataProps="romChartData"/>
			</div>
		</div>
	</section>
</template>
<script>
import RomGraphSection from './romGraphSection'
import GraphSideMenu from './graphSideMenu'
import LoadingOverlay from '@/components/loadingOverlay'
import _API from '@/api'
import {
    _DIRECTION_KEY_RANGE,
    _PART_KEY_RANGE, _EQUIPMENT_KEY_RANGE
} from "@/components/Table/static";
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'RomChangeMonitoringGraph',
  components: {RomGraphSection, GraphSideMenu, LoadingOverlay},
  props: ['patientInfoProps'],
  data() {
    return {
      activeSync: false,
      romChartData: {
        chartData: {},
        requestData: {}
      }
    }
  },
  methods: {
    ...mapGetters(['getReportRomChartData']),
    ...mapActions(['addRomChartDataToVuex']),
    getDataForFilteredRomAndExerciseTimeByRange(requestData) {
      this.activeSync = true;
      return new Promise((_resolve, reject) => {
        _API.MEASURE_RECORD.getDataForFilteredRomAndExerciseTimeByRange(requestData)
            .then(res => {
              this.activeSync = false;
              if (res.data.isSuccess && res.data.failedCode === '0') {
                const chartData = {
                  title: [],
                  date: [],
                  dataOfArom: [],
                  dataOfProm: [],
                  amountOfExercise: []
                }

                // 그래프의 제목 푸쉬
                chartData.title = this.$t(_EQUIPMENT_KEY_RANGE.keyRange[0].trans) + ', ' +
                    this.$t(_PART_KEY_RANGE.data[requestData.position].trans) + ', ' +
                    this.$t(_DIRECTION_KEY_RANGE.data[requestData.direction].trans) + ', ' +
                    this.moment(requestData.startDatetime).locale(this.$t('country')).format('ll') + '~' + this.moment(requestData.endDatetime).locale(this.$t('country')).format('ll');

                // 그래프 데이터 푸쉬
                const dataList = res.data.dataList;
                for (let i = 0; dataList.length > i; i++) {
                  chartData.date.push(this.moment(dataList[i].date).locale(this.$t('country')).format('ll'));
                  chartData.dataOfArom.push(dataList[i].aRom);
                  chartData.dataOfProm.push(dataList[i].pRom);
                  chartData.amountOfExercise.push(dataList[i].duration);

                }
                //내부 데이터 업데이트
                this.$set(this.romChartData, 'chartData', chartData);
                this.$set(this.romChartData, 'requestData', requestData);

                //vuex 데이터 업데이트
                this.addRomChartDataToVuex(this.romChartData);

              } else if (res.data.isSuccess && res.data.failedCode === '1') {
                // 환자의 연동 정보가 없습니다.
                this.$modal.show('common-alert-modal', {
                  messageType: 'short',
                  message: 'alert.no_patient_linkage_information'
                });
              } else if (res.data.isSuccess && res.data.failedCode === '2') {
                // 환자의 활성화된 기기가 없습니다.
                this.$modal.show('common-alert-modal', {
                  messageType: 'short',
                  message: 'alert.no_patient_active_device'
                });
              } else {
                this.$modal.show('common-alert-modal', {
                  messageType: 'short',
                  message: 'alert.unexpected_error'
                });
              }
            })
            .catch(e => {
              reject(`[getDataForFilteredRomAndExerciseTimeByRange] ${e}`);
            });
      });
    },
    calculateRomChartDataFromVuex(data) {
      // vuex로부터 가지고온 값을 안전하게 vue.set 하여 저장합니다.
      // 해당 값의 변화를 감지합니다. 물론 현재 상태에서는 변화를 감지할 포인트는 없습니다만.
      this.$set(this.romChartData, 'chartData', data?.chartData ?? {});
      this.$set(this.romChartData, 'requestData', data?.requestData ?? {});
    },
  },
  mounted() {
    this.calculateRomChartDataFromVuex(this.getReportRomChartData());
  },
  created() {
    this.unsubscribe = this.$store.subscribe((mutation, state) => {
      if (mutation.type === 'setRomChartDataToVuex') {
        this.calculateRomChartDataFromVuex(state.report.romChartData);
      }
      if (mutation.type === 'resetReportToVuex') {
        this.romChartData.chartData = {};
        this.romChartData.requestData = {};
      }
    });
  },
  beforeDestroy() {
    this.unsubscribe();
  },
}
</script>
<style lang="scss">
@import "@/scss/default.scss";
.vld-background {
  border-radius: 10px;
}

.rom-graph-section {
  display: grid;
  grid-template-columns: 1fr 5fr;
  grid-template-rows: 50px 1fr;
  overflow: hidden;
  -webkit-box-flex: 1;
  -ms-flex: 1 1 1rem;
  flex: 1 1 1rem;
  height: 525px;

  &.section_wrap {
    display: flex;
    flex-direction: column;
    justify-content: stretch;
    align-items: stretch;

    .section_title {
      grid-row: 1/2;
      grid-column: 1/3;
    }

    .section_body {
      display: flex;
      flex-direction: row;
      align-items: stretch;
      justify-content: stretch;

      .graph-side-menu-ul {
        margin: 0px 20px 0.5rem 0.5rem;
        width: 250px;
      }

      & #rom_graph {
        @each $value in $height_fill_available {
          #{width} : #{$value};
          #{height} : #{$value};
        }
      }
    }
  }
}
</style>